import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const Footer = ({ isLoggedIn = false }) => {
  const email = isLoggedIn ? "support@prospectconnect.com" : "info@prospectconnect.com";
  
  return (
    <footer className="border-t border-stone bg-paper/50">
      <div className="px-4 py-4">
        <div className="flex flex-col items-center gap-2 text-center text-sm text-muted-foreground">
          <a 
            href={`mailto:${email}`} 
            className="flex items-center gap-2 hover:text-forest transition-colors"
          >
            <Mail className="w-4 h-4" />
            {email}
          </a>
          
          <div className="flex items-center gap-4">
            <Link 
              to="/privacy-policy" 
              className="hover:text-forest transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms-of-service" 
              className="hover:text-forest transition-colors"
            >
              Terms of Service
            </Link>
          </div>
          
          <span>© {new Date().getFullYear()} ProspectConnect</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
